import React, { useState, useEffect } from "react";
import i18n from "i18next";

// Fabric Imports
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import FreigabeDialog from "../../FreigabeDialog/FreigabeDialog";

import { setAppState } from "../../../store/actionCreators";
import { Dispatch } from "redux";
import { useDispatch } from "react-redux";

import { baseUrl } from "../../../helpers/constants";
import DialogEditUserBedarf from "./DialogEditUserBedarf";
import { IAppStateDto } from "../../../Models/IAppStateDto";
import RequestAQuoteDialog from "./RequestAQuoteDialog";
import {
  Badge,
  Text,
  MessageBar,
  Button,
  Tab,
  TabList,
} from "@fluentui/react-components";
import {
  ArrowCounterclockwiseRegular,
  DeleteRegular,
  SendRegular,
  ShoppingBagAddFilled,
  ShoppingBagAddRegular,
  ShoppingBagRegular,
  TaskListSquareAddRegular,
} from "@fluentui/react-icons";
import { IUserBedarfPosition } from "../../../Models/IUserBedarfPosition";
import { BedarfeColumns } from "./BedarfeColumns";
import DialogDeleteBedarfe from "./DialogDeleteBedarfe";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import Header from "../../Layout/Header";
import useWindowSize from "../../../helpers/useWindowSize";
import AddToBedarfDialog from "./AddToBedarfDialog";

interface IBedarfeProps {}

function Bedarfe(props: IBedarfeProps) {
  const [isAddBedarfByNumberOpen, setIsAddBedarfByNumberOpen] =
    useState<boolean>(false);
  const [selectedTabValue, setSelectedTabValue] = useState<string>(
    i18n.t<string>("notSent"),
  );

  const dispatch: Dispatch<any> = useDispatch();
  const windowSize = useWindowSize();
  const [hoveredItem, setHoveredItem] = useState<string>("");
  const [freigabeObjectGuid, setFreigabeObjectGuid] = useState<
    string | undefined
  >(undefined);
  const [sentMessageVisible, setSentMessageVisible] = useState(false);

  const [canDeleteItems, setCanDeleteItems] = useState(false);

  const [bedarfeToDelete, setBedarfeToDelete] = useState<any[]>([]);
  const [deleteBedarfeDialogOpen, setDeleteBedarfeDialogOpen] = useState(false);

  const [requestAQuoteDialogOpen, setRequestAQuoteDialogOpen] = useState(false);
  const emptyList: IUserBedarfPosition[] = [];
  const [selectedItems, setSelectedItems] = useState(emptyList);

  const [resetCheckedItems, setResetCheckedItems] = useState<boolean>(false);
  useEffect(() => {
    const items = selectedItems;
    let canDelete = true;
    if (items.length == 0) {
      // Wenn keine Auswahl, delete Button deaktivieren
      canDelete = false;
    }
    items.forEach((bedarf: any) => {
      // Wenn Bedarf nicht gelöscht werden kann, delete Button deaktivieren
      if (!bedarf.canDeleteObject) {
        canDelete = false;
      }
    });
    setCanDeleteItems(canDelete);
    setSelectedItems(items);
  }, [selectedItems]);
  const bedarfeList: IUserBedarfPosition[] = [];
  const [bedarfe, setBedarfe] = useState({
    notSent: bedarfeList,
    open: bedarfeList,
    finished: bedarfeList,
  });

  const [editBedarf, setEditBedarf] = useState<IUserBedarfPosition | undefined>(
    undefined,
  );

  const columns = BedarfeColumns({
    onItemDeleted: () => {
      getBedarfe();
    },
    checkedItemsGuid: (item: IUserBedarfPosition[]) => {
      setSelectedItems(item);
    },
    resetChecked: resetCheckedItems,
    selectedTab: selectedTabValue,
    allItems:
      selectedTabValue == i18n.t<string>("notSent")
        ? bedarfe.notSent
        : selectedTabValue == i18n.t<string>("open")
        ? bedarfe.open
        : selectedTabValue == i18n.t<string>("finished")
        ? bedarfe.finished
        : [],
    hoveredItem: hoveredItem,
    onOpenEditDialog: (item: string) => {
      editRequest(item);
    },
    freigabeObjectGuid: (item: string) => {
      setFreigabeObjectGuid(item);
    },
  });

  const deleteBedarfe = () => {
    const items: string[] = [];
    selectedItems.forEach((item: IUserBedarfPosition) => {
      items.push(item.userBedarfGuid);
    });

    setBedarfeToDelete(items);
    setDeleteBedarfeDialogOpen(true);
  };

  const deleteRequest = (id: string) => {
    const items: any[] = [];
    items.push(id);
    setBedarfeToDelete(items);
    setDeleteBedarfeDialogOpen(true);
  };

  const editRequest = (id: string) => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/userbedarfe/edit?id=${id}`)
      .then((result: any) => {
        setEditBedarf(result);
      });
  };

  const [loading, setLoading] = useState<boolean>(false);

  const getBedarfe = () => {
    setLoading(true);
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/userbedarfe/getbedarfe?filterOptions=all`)
      .then((data: any) => {
        const notSent: any[] = [];
        const open: any[] = [];
        const finished: any[] = [];

        data.positionen.forEach((element: any, index: number) => {
          if (!element.gesendetAm) {
            // Element wurde noch nicht gesendet
            var tempTestElement = { ...element };
            if (index == 2) {
              tempTestElement.createdBy.fullName = "Lutz";
            }
            notSent.push(tempTestElement);
          } else if (element.gesendetAm && !element.bearbeitetAm) {
            // Element wurde gesendet aber noch kein Angebot erstellt
            open.push(element);
          } else if (element.gesendetAm && element.bearbeitetAm) {
            // Angebot wurde erstellt
            finished.push(element);
          }
        });
        setBedarfe({ notSent: notSent, open: open, finished: finished });
        refreshAppState();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const refreshAppState = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/GetAppState`)
      .then((data: IAppStateDto) => {
        dispatch(setAppState(data));
      });
  };
  useEffect(() => {
    if (resetCheckedItems == true) {
      setTimeout(() => {
        setResetCheckedItems(false);
      }, 600);
    }
  }, [resetCheckedItems]);
  useEffect(() => {
    getBedarfe();
  }, []);

  return (
    <>
      <AddToBedarfDialog
        open={isAddBedarfByNumberOpen}
        onDismiss={() => {
          setIsAddBedarfByNumberOpen(false);
          getBedarfe();
        }}
      />
      <DialogDeleteBedarfe
        itemsToDelete={bedarfeToDelete}
        onDelete={() => {
          getBedarfe();
        }}
        onDismiss={() => {
          setDeleteBedarfeDialogOpen(false);
        }}
        open={deleteBedarfeDialogOpen}
      />
      {freigabeObjectGuid != "" && (
        <FreigabeDialog
          onDismiss={() => {
            setFreigabeObjectGuid(undefined);
          }}
          onSave={() => {
            setFreigabeObjectGuid(undefined);
            getBedarfe();
          }}
          isDialogOpen={freigabeObjectGuid != undefined}
          objectGuid={freigabeObjectGuid}
          objectType="UserBedarf"
          referenceGuid=""
        />
      )}

      {requestAQuoteDialogOpen && (
        <RequestAQuoteDialog
          items={selectedItems}
          isDialogOpen={requestAQuoteDialogOpen}
          onDismiss={() => setRequestAQuoteDialogOpen(false)}
          onQuoteRequested={() => {
            setRequestAQuoteDialogOpen(false);
            getBedarfe();
          }}
        />
      )}
      <DialogEditUserBedarf
        userBedarf={editBedarf}
        isDialogOpen={editBedarf != undefined}
        onDismiss={() => {
          setEditBedarf(undefined);
          getBedarfe();
        }}
      />
      {/*Header*/}
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<ShoppingBagRegular fontSize={24} color="#ff6600" />}
              size="large"
              appearance="subtle"
            >
              {i18n.t<string>("bedarfe").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <Text>{i18n.t<string>("requestsText")}</Text>
      </div>

      {/* CommandBar */}
      <div className="lueb-InnerContentBlockPadding2px ">
        {selectedTabValue == i18n.t<string>("notSent") && (
          <>
            <Button
              disabled={selectedItems.length == 0}
              appearance="transparent"
              icon={<SendRegular />}
              onClick={() => {
                setRequestAQuoteDialogOpen(true);
              }}
            >
              {i18n.t<string>("anfragen")}
            </Button>
            <Button
              disabled={!canDeleteItems}
              appearance="transparent"
              icon={<DeleteRegular />}
              onClick={() => {
                deleteBedarfe();
              }}
            >
              {i18n.t<string>("delete")}
            </Button>
          </>
        )}

        <Button
          icon={<ShoppingBagAddRegular />}
          appearance="transparent"
          onClick={() => {
            setIsAddBedarfByNumberOpen(true);
          }}
        >
          {i18n.t<string>("addBedarfByPartNumber")}
        </Button>

        <Button
          appearance="transparent"
          onClick={() => {
            getBedarfe();
          }}
          disabled={loading}
          icon={<ArrowCounterclockwiseRegular />}
        >
          {i18n.t<string>("refresh")}
        </Button>
      </div>
      {/* CommandBar Ende */}
      <TabList
        onTabSelect={(ev, data) => {
          if (typeof data.value == "string") {
            setSelectedTabValue(data.value);
            setResetCheckedItems(true);
            setSelectedItems([]);
          }
        }}
        defaultSelectedValue={i18n.t<string>("notSent")}
      >
        <Tab value={i18n.t<string>("notSent")}>
          <StackShim
            horizontal
            tokens={{ childrenGap: 3 }}
            verticalAlign="center"
          >
            <div>{i18n.t<string>("notSent")}</div>
            <Badge
              style={{
                background: bedarfe.notSent.length > 0 ? "#ff6600" : "#c1c1c1",
              }}
            >
              {bedarfe.notSent.length}
            </Badge>
          </StackShim>
        </Tab>
        <Tab value={i18n.t<string>("open")}>
          <StackShim
            horizontal
            tokens={{ childrenGap: 3 }}
            verticalAlign="center"
          >
            <div>{i18n.t<string>("open")}</div>
            <Badge
              style={{
                background: bedarfe.open.length > 0 ? "#ff6600" : "#c1c1c1",
              }}
            >
              {bedarfe.open.length}
            </Badge>
          </StackShim>
        </Tab>
        <Tab value={i18n.t<string>("finished")}>
          <StackShim
            horizontal
            tokens={{ childrenGap: 3 }}
            verticalAlign="center"
          >
            <div>{i18n.t<string>("finished")}</div>
            <Badge
              style={{
                background: bedarfe.finished.length > 0 ? "#ff6600" : "#c1c1c1",
              }}
            >
              {bedarfe.finished.length}
            </Badge>
          </StackShim>
        </Tab>
      </TabList>

      <div className="lueb-ContentBlock">
        <LuebPagedDataGrid
          sortable
          resizableColumns
          columnSizingOptions={{
            checkboxId: { defaultWidth: 50, minWidth: 35 },
            artikelId: { defaultWidth: 100, minWidth: 80 },
            hasFreigaben: { defaultWidth: 100, minWidth: 80 },
            benennungDE: { defaultWidth: 310, minWidth: 150 },
            benennungEN: { defaultWidth: 310, minWidth: 150 },
            menge: { defaultWidth: 120, minWidth: 60 },
            kundenReferenz: { defaultWidth: 180, minWidth: 160 },
            "createdBy.fullName": { defaultWidth: 100, minWidth: 80 },
          }}
          items={
            selectedTabValue == i18n.t<string>("notSent")
              ? bedarfe.notSent
              : selectedTabValue == i18n.t<string>("open")
              ? bedarfe.open
              : selectedTabValue == i18n.t<string>("finished")
              ? bedarfe.finished
              : []
          }
          columns={columns}
          /* onItemHover={(item: IUserBedarfPosition) => {
             setHoveredItem(item.userBedarfGuid);
          }} */
        />
        {((selectedTabValue == i18n.t<string>("notSent") &&
          bedarfe.notSent.length == 0) ||
          (selectedTabValue == i18n.t<string>("open") &&
            bedarfe.open.length == 0) ||
          (selectedTabValue == i18n.t<string>("finished") &&
            bedarfe.finished.length == 0)) && (
          <MessageBar style={{ marginTop: "5px" }} intent="info">
            {i18n.t<string>("noItemsFound")}
          </MessageBar>
        )}
      </div>
    </>
  );
}

export default Bedarfe;
